/**
 * External Dependencies
 */
import 'jquery';
import { CountUp } from 'countup.js';
import tippy from 'tippy.js';

$(document).ready(() => {
  // Count Up
    $('[data-countup]').each(function () {
        const el = $(this);
        let id = el.attr('id'),
          count = el.data('countup'),
          decimals = el.parent().data('decimals') ?? 0;

        // Add a unique ID to element
        if (id === undefined) {
            id = 'countup-' + Math.random();
            el.attr('id', id);
        }

        const countUp = new CountUp(id, count, {
            useGrouping: true,
            decimalPlaces: decimals,
            duration: randomIntFromInterval(1.5, 2),
            separator: werepack.thousands_sep,
            decimal: werepack.decimal_point,
            prefix : el.data('countup-prefix') !== undefined ? el.data('countup-prefix') : '',
            suffix : el.data('countup-suffix') !== undefined ? el.data('countup-suffix') : '',
        });

        if (!countUp.error) {
            countUp.start(() => {
                const el = $(this);
                if (el.next().hasClass('celebrate')) {
                    el.next().addClass('sparkles');
                }
            });
        }
    });

  // Tooltip
  tippy('[data-tippy-content]', {
        theme: 'light',
    });

});

function randomIntFromInterval(min, max)
{
    return (Math.random() * (max - min + 1) + min).toFixed(2);
}
